import { createStore } from 'vuex'
import actions from './actions'
import getters from './getters'
import initialState from './initialState'
import VuexPersistence from 'vuex-persist'
import createMultiTabState from 'vuex-multi-tab-state'

const vuexLocal = new VuexPersistence({
	storage: window.localStorage,
	key: 'revodataV2',
	reducer: (state: any) => {
		return {
			// user: state.user,
			locale: state.locale,
			// userTheme: state.userTheme,
			version: state.version,
			locations: state.locations,
			projects: state.projects,
			comapps: state.comapps,
			users: state.users,
			customGraphs: state.customGraphs,
			modules: state.modules,
			hubs: state.hubs,
			// d3Data: state.d3Data,
		}
	},
})

const multiTab = createMultiTabState({
	statesPaths: [
		'userTheme',
		// 'user.accessToken',
		// 'user._id',
		// 'user.email',
		// 'user.role',
		// 'locale',
		// 'd3Data',
		// 'd3DataExtentXFrom',
		// 'd3DataExtentXTo',
	],
	// onBeforeSave: (state) => {
	// 	console.log('onBeforeSave',state);
	//   // Modify state here
	//   return state;
	// },
	// onBeforeReplace: (state) => {
	// 	// console.log('onBeforeReplace',state);
	// 	// console.log('onBeforeReplace',state.userTheme);
	//   // Modify state here
	//   return state;
	// }
})

const plugins = [vuexLocal.plugin, multiTab]
// const plugins = [vuexLocal.plugin];
// const plugins = [multiTab];

export default createStore({
	plugins,
	state: initialState,
	mutations: {
		// updateUserData(s: any, userData: any) {
		// 	s.user = { ...s.user, ...userData }
		// },

		set(s: any, v: any) {
			// console.log(v);
			const [a, b] = v
			s[a] = b
		},
		d3set(s: any, v: any) {
			// console.log(v);
			const [a, b] = v
			s.d3Data.from = a
			s.d3Data.to = b
			// s.d3Data[a] = b
		},

		reset(s: any, key: any) {
			const locInitialState: any = initialState()
			const initStateVal: any = locInitialState[key]
			s[key] = initStateVal
		},

		resetAll(s: any, key: any) {
			const locInitialState: any = initialState()
			s = locInitialState
		},

		// SOCKET_LETEST(s: any, data: any) {
		//   console.log("SOCKET_LETEST mutations", data);
		// },

		// resetstate(state: any) {
		//   let exceptkeys = ["isUsingOffline"]
		//   const s: any = initialState.default();
		//   Object.keys(s).forEach(key => {
		//     if (!exceptkeys.includes(key))
		//       state[key] = s[key];
		//   });
		// },
	},
	getters,
	actions,
	modules: {},
})

// //? helper functions

// const convertArrayToObject = (array: any, key: string) => {
//   const initialValue = {};
//   return array.reduce((obj: any, item: any) => {
//     return {
//       ...obj,
//       [item[key]]: item,
//     };
//   }, initialValue);
// };
